import type { ColDef, ValueFormatterParams } from 'ag-grid-community';

import { TableHeaderWithTooltipIcon } from '~/components/common';

import { formatNumber } from '~/utils/common';

import type { TypeStockSku } from '~/types/stock.types';

/**
 * [재고관리 > 상품별 조회] 페이지 테이블
 */
const getStockSkuColumnDefs = () => {
  const columnDefs: ColDef<TypeStockSku>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'alterCode',
      headerName: '상품 바코드',
      width: 150,
    },
    {
      field: 'skuCode',
      headerName: 'SKU코드',
      width: 140,
    },
    {
      field: 'clusterName',
      headerName: '보관 센터',
      width: 80,
    },
    {
      field: 'skuName',
      headerName: '상품명',
      minWidth: 210,
      flex: 1,
    },
    {
      field: 'temperatureType',
      headerName: '보관 유형',
      width: 92,
    },
    {
      field: 'totalQuantity',
      headerName: '전체 재고',
      width: 80,
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({ value }: ValueFormatterParams<TypeStockSku, TypeStockSku['totalQuantity']>) => {
        return value ? formatNumber(value) : '-';
      },
    },
    {
      field: 'availableQuantity',
      headerName: '가용 재고',
      headerComponent: TableHeaderWithTooltipIcon,
      headerComponentParams: {
        tooltipDescription: '고객에게 판매 가능한 재고입니다.',
        tooltipMaxWidth: '182px',
      },
      cellClass: 'overflow-visible',
      width: 96,
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({ value }: ValueFormatterParams<TypeStockSku, TypeStockSku['availableQuantity']>) => {
        return value ? formatNumber(value) : '-';
      },
    },
    {
      field: 'allocationQuantity',
      headerName: '작업중 재고',
      headerComponent: TableHeaderWithTooltipIcon,
      headerComponentParams: {
        tooltipDescription: '주문이 들어와 생산 중이거나, 이동 중인 재고입니다.',
        tooltipMaxWidth: '266px',
      },
      width: 112,
      cellClass: 'overflow-visible',
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({ value }: ValueFormatterParams<TypeStockSku, TypeStockSku['allocationQuantity']>) => {
        return value ? formatNumber(value) : '-';
      },
    },
    {
      field: 'holdingQuantity',
      headerName: '보류 재고',
      headerComponent: TableHeaderWithTooltipIcon,
      headerComponentParams: {
        tooltipDescription:
          '가용 혹은 불용 재고 여부를 판단하기 위해 대기중인 재고,\n혹은 반출/폐기로 인해 센터에서 사라질 예정인 재고입니다.',
        tooltipMaxWidth: '299px',
      },
      width: 96,
      cellClass: 'overflow-visible',
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({ value }: ValueFormatterParams<TypeStockSku, TypeStockSku['holdingQuantity']>) => {
        return value ? formatNumber(value) : '-';
      },
    },
    {
      field: 'defectiveQuantity',
      headerName: '불용 재고',
      headerComponent: TableHeaderWithTooltipIcon,
      headerComponentParams: {
        tooltipDescription: '판매 불가한 재고입니다.',
        tooltipMaxWidth: '137px',
      },
      width: 96,
      cellClass: 'overflow-visible',
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({ value }: ValueFormatterParams<TypeStockSku, TypeStockSku['defectiveQuantity']>) => {
        return value ? formatNumber(value) : '-';
      },
    },
  ];

  return { columnDefs };
};

export default getStockSkuColumnDefs;
